import './ListingItem.scss';

import { Button, Icon, LineSeparator } from '@icarros/torque-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import defaultCarImage from '../../assets/images/default-error.png';
import { getStatus } from '../../utils/config/listingsStatus';
import { formatImageUrl, formatMileage, formatMoney, formatYearModel } from '../../utils/format';
import CardImage from '../CardImage';

class ListingItem extends Component {
  constructor(props) {
    super(props);

    this.goToListing = this.goToListing.bind(this);
    this.resolveAction = this.resolveAction.bind(this);
  }

  resolveAction(e, currentAction) {
    const { history, location, link, current } = this.props;

    const { id } = current;

    e.stopPropagation();

    if (currentAction && currentAction.redirect) {
      history.push({
        pathname: currentAction.redirect.replace('#id', id),
        state: { location }
      });
    }

    if (currentAction?.redirectToLink) {
      window.location.href = link;
    }

    if (currentAction?.incomplete) {
      window.open(current.incompleteURL, '_blank');
    }

    if (currentAction?.payNow) {
      window.open(current.paymentURL, '_blank');
    }
  }

  goToListing(e) {
    const { current } = this.props;
    const { link } = current;

    e.stopPropagation();

    window.open(link, '_blank');
  }

  deleteFavorite(e, id) {
    const { onDelete } = this.props;

    e.stopPropagation();

    if (onDelete) {
      onDelete(id);
    }
  }

  render() {
    const {
      parentId,
      className,
      hasStatus,
      hideDescription,
      showListingAgent,
      onClick,
      canDelete,
      current
    } = this.props;

    const {
      id,
      price,
      mileage,
      versionName,
      brandName,
      modelName,
      text,
      manufacturingYear,
      yearModel,
      colorName,
      gearName,
      images,
      cityName,
      stateId,
      listingAgentName
    } = current;

    const currentStatus = hasStatus && getStatus(current);

    const mainImage = (() => {
      if (images?.length) {
        const orderedImages = images.sort((a, b) => {
          if (a.order < b.order) {
            return -1;
          }

          if (a.order > b.order) {
            return 1;
          }

          return 0;
        });

        return orderedImages[0];
      }
      return null;
    })();

    const imageUrl = (() => {
      if (mainImage?.id) {
        return formatImageUrl(mainImage.id);
      }
      return defaultCarImage;
    })();

    return (
      <div
        id={parentId}
        className={classNames('listing-item', {
          'listing-item--clickable': onClick,
          [className]: className
        })}
        onClick={onClick}
        onKeyDown={onClick}
        role="button"
        tabIndex="0"
      >
        <CardImage imageUrl={imageUrl}>
          <>
            <div className="listing-item__primary">
              {canDelete && (
                <Icon
                  className="listing-item__delete btn_qa_favorito"
                  name="delete"
                  onClick={e => this.deleteFavorite(e, id)}
                  title="Excluir"
                />
              )}
              {hasStatus && currentStatus && (
                <span
                  className={classNames('listing-item__status msg_qa_status', {
                    [`listing-item__status--${currentStatus?.color}`]: currentStatus?.color
                  })}
                >
                  {currentStatus.label}
                </span>
              )}
              <span className="listing-item__price">{formatMoney(price)}</span>
              <div className="listing-item__name-model">
                <span className="listing-item__name">
                  {brandName} {modelName}
                </span>
                <span className="listing-item__model">{versionName}</span>
              </div>
              <div className="listing-item__features">
                {manufacturingYear && yearModel && (
                  <span className="listing-item__feature">
                    {formatYearModel(manufacturingYear, yearModel)}
                  </span>
                )}
                {(mileage !== null || mileage !== undefined) && (
                  <span className="listing-item__feature">{formatMileage(mileage)}</span>
                )}
                {colorName && <span className="listing-item__feature">{colorName}</span>}
                {gearName && <span className="listing-item__feature">{gearName}</span>}
              </div>
              {!hideDescription && <span className="listing-item__description">{text}</span>}
            </div>
            <div className="listing-item__secondary">
              <LineSeparator />
              <div className="actions-container">
                {showListingAgent && (
                  <div className="actions-container__listing-agent">
                    {!!listingAgentName && (
                      <span id="txt_qa_tipoAnunciante" className="actions-container__item">
                        {listingAgentName}
                      </span>
                    )}
                    {!!cityName && stateId && (
                      <span id="txt_qa_cidade" className="actions-container__item">
                        {`${cityName} - ${stateId}`}
                      </span>
                    )}
                  </div>
                )}
                {hasStatus &&
                  currentStatus &&
                  currentStatus.actions.map(elem => (
                    <Button
                      className={classNames('actions-container__button', {
                        [elem?.className]: elem?.className
                      })}
                      key={`button-${elem.label}`}
                      small
                      ghost
                      colorSecondary
                      onClick={e => this.resolveAction(e, elem)}
                    >
                      {elem.label}
                    </Button>
                  ))}
                {!hasStatus && (
                  <Button
                    className="actions-container__button btn_qa_verAnuncio"
                    small
                    ghost
                    colorSecondary
                    onClick={this.goToListing}
                    title="Ver Anúncio"
                  >
                    Ver Anúncio
                  </Button>
                )}
              </div>
            </div>
          </>
        </CardImage>
      </div>
    );
  }
}

ListingItem.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  location: PropTypes.shape({}),
  link: PropTypes.string,
  parentId: PropTypes.string,
  className: PropTypes.string,
  hasStatus: PropTypes.bool,
  hideDescription: PropTypes.bool,
  showListingAgent: PropTypes.bool,
  canDelete: PropTypes.bool,
  current: PropTypes.shape({
    id: PropTypes.number,
    link: PropTypes.string,
    incompleteURL: PropTypes.string,
    paymentURL: PropTypes.string,
    price: PropTypes.number,
    mileage: PropTypes.number,
    versionName: PropTypes.string,
    brandName: PropTypes.string,
    modelName: PropTypes.string,
    text: PropTypes.string,
    manufacturingYear: PropTypes.number,
    yearModel: PropTypes.number,
    colorName: PropTypes.string,
    gearName: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        order: PropTypes.number
      })
    ),
    cityName: PropTypes.string,
    stateId: PropTypes.string,
    listingAgentName: PropTypes.string
  }),
  onDelete: PropTypes.func,
  onClick: PropTypes.func
};

export default withRouter(ListingItem);
